export default __webpack_public_path__ + "static/media/pa.e5963368.jpg";